import { NocoHttpClient } from '@noco/http-client';
import { createConfigurationWithToken } from '../utils';
var Configuration = NocoHttpClient.Configuration;
var VisitorApi = /** @class */ (function () {
    function VisitorApi(basePath, fetchApi) {
        this.basePath = basePath;
        this.fetchApi = fetchApi;
    }
    VisitorApi.initialize = function (basePath, fetchApi) {
        if (!VisitorApi.instance) {
            VisitorApi.instance = new VisitorApi(basePath, fetchApi);
        }
        return VisitorApi.instance;
    };
    VisitorApi.prototype.ApiFactory = function (idToken) {
        var config = createConfigurationWithToken({
            basePath: this.basePath,
            fetchApi: this.fetchApi,
            idToken: idToken,
            type: 'contact'
        });
        return new NocoHttpClient.ApiContactV1VisitorApi(new Configuration(config));
    };
    return VisitorApi;
}());
export { VisitorApi };
